module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<div class=\"container\">\n  <h1>\n    ngx-d3-tooltip\n  </h1>\n  <p>\n     Add tooltips to your d3 visualizations using Angular Components.\n  </p>\n\n   <interactive-pie-chart [data]=\"pieData\"></interactive-pie-chart>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/andyperlitch/repos/ngx-d3-tooltip/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main